import axios from 'axios';

import { parameters } from '../../constants/parameters';
import { Location } from '../../entities/location';

export interface LocationPayload extends Partial<Location> {
  productIds?: number[];
  siteIds?: number[];
}

const authHeaders = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export const list = async (token: string): Promise<Location[]> => {
  const url = `${parameters.api.baseUrl}/locations/admin/list`;

  const res = await axios.get(url, authHeaders(token));

  return res.data;
};

export const one = async (token: string, id: number): Promise<Location> => {
  const url = `${parameters.api.baseUrl}/locations/admin/${id}`;

  const res = await axios.get(url, authHeaders(token));

  return res.data;
};

export const create = async (token: string, payload: LocationPayload): Promise<Location> => {
  const url = `${parameters.api.baseUrl}/locations/admin`;

  const res = await axios.put(url, payload, authHeaders(token));

  return res.data;
};

export const update = async (token: string, id: number, payload: LocationPayload): Promise<Location> => {
  const url = `${parameters.api.baseUrl}/locations/admin/${id}`;

  const res = await axios.post(url, payload, authHeaders(token));

  return res.data;
};

export const remove = async (token: string, id: number): Promise<void> => {
  const url = `${parameters.api.baseUrl}/locations/admin/${id}`;

  await axios.delete(url, authHeaders(token));
};
